module.exports = __webpack_public_path__ + "static/img/subcontract13.d576555e.png";